import { motion } from "framer-motion";
import { Clock, MapPin, BadgeCheck } from "lucide-react";
import { IMG, waLink } from "../../data";
import { WhatsAppIcon } from "./WhatsAppIcon";

const ease = [0.22, 1, 0.36, 1];
const LINES = ["Sentuhan Traditional", "Massage ke", "Tempat Anda"];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.25 } },
};
const line = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1, ease } },
};

export const Hero = () => (
  <section className="relative min-h-[100svh] flex items-end overflow-hidden bg-[#2c1e16]">
    <motion.div
      className="absolute inset-0"
      initial={{ scale: 1.15 }}
      animate={{ scale: 1 }}
      transition={{ duration: 1.8, ease }}
    >
      <img
        src={IMG.hero}
        alt="Terapis Javanese Spa Jogja sedang memberikan Massage tradisional"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#2c1e16] via-[#2c1e16]/40 to-[#2c1e16]/20" />
      <div className="absolute inset-0 bg-[#2c1e16]/20" />
    </motion.div>

    <div className="relative z-10 w-full mx-auto max-w-7xl px-5 sm:px-8 pb-16 sm:pb-24 pt-32">
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.8, ease }}
        className="uppercase text-xs tracking-[0.28em] text-[#e5d9c5] mb-6"
      >
        Massage Panggilan · Yogyakarta
      </motion.p>

      <motion.h1
        variants={container}
        initial="hidden"
        animate="show"
        className="font-display text-[#faf7f2] text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-4xl"
      >
        {LINES.map((t, i) => (
          <span key={i} className="block overflow-hidden">
            <motion.span variants={line} className="block">
              {t}
            </motion.span>
          </span>
        ))}
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.9, duration: 0.9, ease }}
        className="mt-8 max-w-xl text-[#e5d9c5] text-base sm:text-lg leading-relaxed"
      >
        Terapis profesional & bersertifikat datang ke hotel, rumah, villa,
        atau di mana pun Anda berada. Bebas uang transport, siap melayani 24
        jam.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.1, duration: 0.9, ease }}
        className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4"
      >
        <a
          href={waLink("Halo Javanese Spa Jogja, saya ingin booking Massage panggilan.")}
          target="_blank"
          rel="noreferrer"
          data-testid="hero-booking-btn"
          className="inline-flex items-center gap-2 rounded-full bg-[#b8862f] text-[#2c1e16] px-8 py-4 text-sm font-medium hover:bg-[#faf7f2] transition-colors"
        >
          <WhatsAppIcon className="h-5 w-5" />
          Booking via WhatsApp
        </a>
        <a
          href="#layanan"
          data-testid="hero-services-link"
          className="rounded-full border border-[#faf7f2]/40 text-[#faf7f2] px-8 py-4 text-sm hover:bg-[#faf7f2]/10 transition-colors"
        >
          Lihat Layanan
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.35, duration: 1 }}
        className="mt-12 flex flex-wrap gap-x-8 gap-y-3 text-[#e5d9c5] text-sm"
      >
        <span className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-[#b8862f]" /> Buka 24 Jam
        </span>
        <span className="flex items-center gap-2">
          <BadgeCheck className="h-4 w-4 text-[#b8862f]" /> Terapis Bersertifikat
        </span>
        <span className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-[#b8862f]" /> Bebas Uang Transport
        </span>
      </motion.div>
    </div>
  </section>
);
